import BliModal from '@blibli/blue.modal/dist/modal/blue/Modal'
import BliModalHeader from '@blibli/blue.modal/dist/modal/blue/ModalHeader'
import BliModalBody from '@blibli/blue.modal/dist/modal/blue/ModalBody'
import BliModalFooter from '@blibli/blue.modal/dist/modal/blue/ModalFooter'
import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import BliIconSiReviewRating from '@blibli/blue-dls-library-icon/dist/ReviewRating'
import BliRating from '@blibli/blue.rating/dist/rating/blue/Rating'
import BliField from '@blibli/blue.field/dist/field/blue/Field'
import BliTextArea from '@blibli/blue.text-area/dist/text-area/blue/TextArea'
import CommonMixin from '@vue3/mixins/commonMixin.js'
import { mapState, mapActions } from 'pinia'
import NpsStore from '@vue3/store/nps-store'


export default {
  name: 'NpsModal',
  components: {
    BliField,
    BliRating,
    BliModal,
    BliButton,
    BliTextArea,
    BliModalHeader,
    BliModalBody,
    BliModalFooter,
    BliIconSiReviewRating
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rating: 0,
      comments: '',
      isLoading: false
    }
  },
  emits: ['closeModal', 'onPrimaryClick', 'onTertiaryClick'],
  mixins: [CommonMixin],
  computed: {
    ...mapState(NpsStore, ['feedbackId']),
    ratingText () {
      return this.$t(`npsFeedback.rating.star_${this.rating}`)
    }
  },
  methods: {
    ...mapActions(NpsStore, ['saveNpsFeedback', 'cancelNpsFeedback']),
    dontAllowCertainSpecialCharacters (event) {
      if (/[&$<>'"]/.test(event.key)) {
        event.preventDefault()
      }
    },
    handlePaste (event) {
      const pasteData = (event.clipboardData || window.clipboardData).getData('text')
      if (/[&$<>'"]/.test(pasteData)) {
        event.preventDefault()
      }
    },
    onSaveNpsFeedback () {
      if (this.isLoading) {
        return
      }
      const payload = {
        feedbackId: this.feedbackId,
        rating: this.rating
      }
      if (this.comments) {
        payload.description = this.comments
      }
      this.isLoading = true
      this.saveNpsFeedback({
        payload: payload,
        success: this.onSuccessSaveNPS,
        fail: this.onFailSaveNPS
      })
    },
    onSuccessSaveNPS () {
      this.isLoading = false
      this.clearNpsRating()
      this.showToast('', this.$t('npsFeedback.toast.success'))
    },
    onFailSaveNPS () {
      this.isLoading = false
      this.showToast('error', this.$t('npsFeedback.toast.fail'))
    },
    onCancelNpsFeedback () {
      this.cancelNpsFeedback({
        payload: { feedbackId: this.feedbackId },
        success: this.clearNpsRating
      })
    },
    clearNpsRating () {
      this.rating = 0
      this.comments = ''
    }
  }
}
